<template>
  <ContentSection>
    <Container :indent="indentation">
      <!-- Single image -->
      <AppImage
        v-if="data.images && data.images.length === 1"
        :asset="data.images"
        class="w-full object-cover"
        :class="{ 'h-80 lg:h-[27.5rem]': data.is_full_width }"
      />

      <!-- Two images -->
      <div
        v-if="data.images && data.images.length > 1"
        class="flex flex-col gap-4 md:flex-row md:gap-5"
      >
        <AppImage
          v-for="image in data.images"
          :key="image.id"
          :asset="image"
          class="w-full object-cover"
          :class="{ 'h-80 lg:h-[27.5rem]': data.is_full_width }"
        />
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { AssetFragment } from '#gql'

const props = defineProps<{
  data: {
    images: AssetFragment[]
    is_full_width: boolean
  }
}>()

const indentation = computed(() => {
  return props.data.is_full_width ? null : 'center'
})
</script>
